import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';

export default function Attendance() {
  const navigate = useNavigate();
  const [currentTime] = useState(new Date());
  const [isCheckedIn, setIsCheckedIn] = useState(false);
  const [showLeaveForm, setShowLeaveForm] = useState(false);
  const [leaveFormData, setLeaveFormData] = useState({
    type: '',
    startDate: '',
    endDate: '',
    reason: '',
    phone: '',
    email: ''
  });

  const attendanceHistory = [
    {
      date: '2024-01-15',
      checkIn: '08:00',
      checkOut: '17:00',
      hours: '9 ساعات',
      status: 'حاضر',
      project: 'معرض الرياض الدولي'
    },
    {
      date: '2024-01-14',
      checkIn: '08:15',
      checkOut: '17:30',
      hours: '9.25 ساعة',
      status: 'حاضر',
      project: 'معرض الرياض الدولي'
    },
    {
      date: '2024-01-13',
      checkIn: '-',
      checkOut: '-',
      hours: '-',
      status: 'إجازة',
      project: '-'
    }
  ];

  const handleCheckIn = () => {
    setIsCheckedIn(true);
  };

  const handleCheckOut = () => {
    setIsCheckedIn(false);
  };

  const handleLeaveFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append('type', leaveFormData.type);
    formData.append('startDate', leaveFormData.startDate);
    formData.append('endDate', leaveFormData.endDate);
    formData.append('reason', leaveFormData.reason);
    formData.append('phone', leaveFormData.phone);
    formData.append('email', leaveFormData.email);

    try {
      const response = await fetch('https://readdy.ai/api/form/d49ggqh7bl57tkq9h50g', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        alert('تم إرسال طلب الإجازة بنجاح');
        setShowLeaveForm(false);
        setLeaveFormData({
          type: '',
          startDate: '',
          endDate: '',
          reason: '',
          phone: '',
          email: ''
        });
      } else {
        alert('حدث خطأ في إرسال الطلب');
      }
    } catch (error) {
      alert('حدث خطأ في إرسال الطلب');
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-SA', { 
      weekday: 'long',
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'حاضر': return 'text-[#4CAF50] bg-[#4CAF50]/10';
      case 'غائب': return 'text-red-500 bg-red-50';
      case 'إجازة': return 'text-[#FBC02D] bg-[#FBC02D]/10';
      case 'تأخير': return 'text-[#FF9800] bg-[#FF9800]/10';
      default: return 'text-[#757575] bg-[#F5F5F5]';
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <TopNavigation 
        title="الحضور والانصراف"
        leftAction={
          <button 
            onClick={() => navigate('/dashboard')}
            className="w-8 h-8 flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        }
        rightAction={
          <button className="w-8 h-8 flex items-center justify-center">
            <i className="ri-calendar-line text-lg"></i>
          </button>
        }
      />

      <div className="pt-14 pb-20 px-4">
        {/* Current Status */}
        <Card className="mb-6 mt-4 text-center bg-gradient-to-r from-[#1565C0] to-[#1976D2] text-white">
          <div className="py-6">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-2xl"></i>
            </div>
            <h2 className="text-xl font-bold mb-2">
              {currentTime.toLocaleTimeString('ar-SA', { 
                hour: '2-digit', 
                minute: '2-digit' 
              })}
            </h2>
            <p className="text-white/90 mb-4">
              {formatDate(currentTime.toISOString())}
            </p>
            <div className="flex items-center justify-center">
              <div className={`w-3 h-3 rounded-full ml-2 ${isCheckedIn ? 'bg-[#4CAF50]' : 'bg-white/50'}`}></div>
              <span className="text-sm">
                {isCheckedIn ? 'تم تسجيل الحضور' : 'لم يتم تسجيل الحضور'}
              </span>
            </div>
          </div>
        </Card>

        {/* Check In/Out Buttons */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <Button
            variant={isCheckedIn ? "secondary" : "primary"}
            onClick={handleCheckIn}
            disabled={isCheckedIn}
            className="py-4"
          >
            <div className="text-center">
              <i className="ri-login-circle-line text-xl mb-2 block"></i>
              <span className="text-sm">تسجيل الحضور</span>
            </div>
          </Button>
          <Button
            variant={!isCheckedIn ? "secondary" : "primary"}
            onClick={handleCheckOut}
            disabled={!isCheckedIn}
            className="py-4"
          >
            <div className="text-center">
              <i className="ri-logout-circle-line text-xl mb-2 block"></i>
              <span className="text-sm">تسجيل الانصراف</span>
            </div>
          </Button>
        </div>

        {/* Quick Actions */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <button 
            className="bg-white rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow"
            onClick={() => navigate('/attendance/history')}
          >
            <div className="text-center">
              <div className="w-12 h-12 bg-[#607D8B]/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-history-line text-[#607D8B] text-xl"></i>
              </div>
              <h4 className="font-semibold text-[#333333] text-sm mb-1">سجل الحضور</h4>
              <p className="text-[#757575] text-xs">عرض التاريخ</p>
            </div>
          </button>
          <button 
            className="bg-white rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow"
            onClick={() => setShowLeaveForm(true)}
          >
            <div className="text-center">
              <div className="w-12 h-12 bg-[#FBC02D]/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-calendar-todo-line text-[#FBC02D] text-xl"></i>
              </div>
              <h4 className="font-semibold text-[#333333] text-sm mb-1">طلب إجازة</h4>
              <p className="text-[#757575] text-xs">إجازة مرضية أو عادية</p>
            </div>
          </button>
        </div>

        {/* Today's Summary */}
        <Card className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">ملخص اليوم</h3>
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <p className="text-2xl font-bold text-[#4CAF50]">8.5</p>
              <p className="text-[#757575] text-xs">ساعات العمل</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-[#1565C0]">0</p>
              <p className="text-[#757575] text-xs">دقائق التأخير</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-[#FBC02D]">1</p>
              <p className="text-[#757575] text-xs">استراحة</p>
            </div>
          </div>
        </Card>

        {/* Recent Attendance */}
        <Card>
          <h3 className="text-lg font-semibold text-[#333333] mb-4">الحضور الأخير</h3>
          <div className="space-y-4">
            {attendanceHistory.slice(0, 3).map((record, index) => (
              <div key={index} className="flex items-center justify-between py-2">
                <div className="flex-1">
                  <p className="font-medium text-[#333333] text-sm">
                    {new Date(record.date).toLocaleDateString('ar-SA', { 
                      month: 'short', 
                      day: 'numeric' 
                    })}
                  </p>
                  <p className="text-[#757575] text-xs">{record.project}</p>
                </div>
                <div className="text-center mx-4">
                  <p className="text-[#333333] text-sm font-medium">{record.hours}</p>
                  <p className="text-[#757575] text-xs">
                    {record.checkIn} - {record.checkOut}
                  </p>
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(record.status)}`}>
                  {record.status}
                </span>
              </div>
            ))}
          </div>
          <Button 
            variant="outline" 
            size="sm" 
            className="w-full mt-4"
            onClick={() => navigate('/attendance/history')}
          >
            عرض السجل الكامل
          </Button>
        </Card>
      </div>

      {/* Leave Request Form Modal */}
      {showLeaveForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-[#333333]">طلب إجازة</h3>
                <button 
                  onClick={() => setShowLeaveForm(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
                >
                  <i className="ri-close-line text-lg"></i>
                </button>
              </div>

              <form onSubmit={handleLeaveFormSubmit} data-readdy-form>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-[#333333] mb-2">
                      نوع الإجازة
                    </label>
                    <select
                      name="type"
                      value={leaveFormData.type}
                      onChange={(e) => setLeaveFormData({...leaveFormData, type: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1565C0] text-sm"
                      required
                    >
                      <option value="">اختر نوع الإجازة</option>
                      <option value="sick">إجازة مرضية</option>
                      <option value="annual">إجازة سنوية</option>
                      <option value="emergency">إجازة طارئة</option>
                      <option value="personal">إجازة شخصية</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#333333] mb-2">
                      تاريخ البداية
                    </label>
                    <input
                      type="date"
                      name="startDate"
                      value={leaveFormData.startDate}
                      onChange={(e) => setLeaveFormData({...leaveFormData, startDate: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1565C0] text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#333333] mb-2">
                      تاريخ النهاية
                    </label>
                    <input
                      type="date"
                      name="endDate"
                      value={leaveFormData.endDate}
                      onChange={(e) => setLeaveFormData({...leaveFormData, endDate: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1565C0] text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#333333] mb-2">
                      رقم الهاتف
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={leaveFormData.phone}
                      onChange={(e) => setLeaveFormData({...leaveFormData, phone: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1565C0] text-sm"
                      placeholder="05xxxxxxxx"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#333333] mb-2">
                      البريد الإلكتروني
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={leaveFormData.email}
                      onChange={(e) => setLeaveFormData({...leaveFormData, email: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1565C0] text-sm"
                      placeholder="example@email.com"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#333333] mb-2">
                      سبب الإجازة
                    </label>
                    <textarea
                      name="reason"
                      value={leaveFormData.reason}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) {
                          setLeaveFormData({...leaveFormData, reason: e.target.value});
                        }
                      }}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1565C0] text-sm resize-none"
                      rows={4}
                      placeholder="اكتب سبب طلب الإجازة..."
                      maxLength={500}
                      required
                    />
                    <p className="text-xs text-[#757575] mt-1">
                      {leaveFormData.reason.length}/500 حرف
                    </p>
                  </div>
                </div>

                <div className="flex gap-3 mt-6">
                  <Button
                    type="button"
                    variant="secondary"
                    className="flex-1"
                    onClick={() => setShowLeaveForm(false)}
                  >
                    إلغاء
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    className="flex-1"
                    disabled={!leaveFormData.type || !leaveFormData.startDate || !leaveFormData.endDate || !leaveFormData.reason.trim() || !leaveFormData.phone || !leaveFormData.email}
                  >
                    إرسال الطلب
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <BottomNavigation />
    </div>
  );
}